// src/config/relicVault/companions.js
//
// Guardian companions - one per guild. Ported from the designer's handoff
// (relic-vault-react src/data/companions.ts); names, guilds, colors, traits,
// icon kinds and prices are unchanged.
//
// Art is looked up by `guildId` from images/RelicVault:
//   COMPANION_ART[guildId]   cropped character art (store card, vault header)
//   COMPANION_INTRO[guildId] full "Meet <name>" reveal (purchase modal only)
//
// `unityGuardianId` is the contract with Unity. React sends
// `set_guardian <unityGuardianId>` and Unity's Guardian_Controller resolves it
// against the catalog on the Guys_Man_Base / Guys_Woman_Base prefabs, where
// the 3D models are registered as g1..g9. The pairing below was matched by
// comparing each model's texture to the designer's character art.
//
// Companions are owned and equipped by `guildId`, never by `id`.

export const COMPANION_NONE_ID = 'none';

export const COMPANIONS = [
  {
    id: 'c1',
    name: 'Quik',
    guild: 'Progression Guild',
    color: '#3A7D2C',
    guildId: 'quik',
    traits: 'Brave • Loyal • Adventurous',
    iconKind: 'mountain',
    price: 1000,
    unityGuardianId: 'g5', // border collie
  },
  {
    id: 'c3',
    name: 'Ember',
    guild: 'Flame Guild',
    color: '#E8563C',
    guildId: 'ember',
    traits: 'Bold • Creative • Fearless',
    iconKind: 'flame',
    price: 1000,
    unityGuardianId: 'g3', // phoenix
  },
  {
    id: 'c4',
    name: 'Echo',
    guild: 'Secret Society',
    color: '#4A5FD9',
    guildId: 'echo',
    traits: 'Curious • Clever • Unique',
    iconKind: 'moon',
    price: 1000,
    unityGuardianId: 'g8', // ghost
  },
  {
    id: 'c6',
    name: 'Holly',
    guild: 'Festival Guild',
    color: '#E85D97',
    guildId: 'holly',
    traits: 'Kind • Joyful • Inclusive',
    iconKind: 'flower',
    price: 1000,
    unityGuardianId: 'g6', // hedgehog
  },
  {
    id: 'c5',
    name: 'Atlas',
    guild: 'Victory Guild',
    color: '#2A4E8C',
    guildId: 'atlas',
    traits: 'Steady • Strong • Determined',
    iconKind: 'mountain',
    price: 1000,
    unityGuardianId: 'g7', // turtle
  },
  {
    id: 'c8',
    name: 'Astra',
    guild: 'Mastery Guild',
    color: '#8B5CF6',
    guildId: 'astra',
    traits: 'Wise • Curious • Magical',
    iconKind: 'star',
    price: 1000,
    unityGuardianId: 'g9', // owl
  },
  {
    id: 'c7',
    name: 'Newton',
    guild: 'Perseverance Guild',
    color: '#3E8C6E',
    guildId: 'newton',
    traits: 'Resilient • Resourceful • Positive',
    iconKind: 'leaf',
    price: 1000,
    unityGuardianId: 'g4', // chameleon
  },
  {
    id: 'c9',
    name: 'Nova',
    guild: 'Creator Guild',
    color: '#9D6CFF',
    guildId: 'nova',
    traits: 'Innovative • Imaginative • Bold',
    iconKind: 'gear',
    price: 1000,
    unityGuardianId: 'g2', // robot
  },
  {
    id: 'c2',
    name: 'Ace',
    guild: "Scholar's Guild",
    color: '#6B9E3F',
    guildId: 'ace',
    traits: 'Smart • Supportive • Driven',
    iconKind: 'book',
    price: 1000,
    unityGuardianId: 'g1', // fox
  },
];

const companionByGuildId = new Map(COMPANIONS.map(c => [c.guildId, c]));

export function getCompanionForGuild(guildId) {
  return companionByGuildId.get(guildId);
}

/**
 * Unity guardian id for an equipped companion's guildId.
 * Returns "none" for no companion or an unknown guild, so Unity hides it.
 */
export function unityGuardianIdFor(guildId) {
  if (!guildId || guildId === COMPANION_NONE_ID) return COMPANION_NONE_ID;
  return companionByGuildId.get(guildId)?.unityGuardianId || COMPANION_NONE_ID;
}

export default COMPANIONS;
